<template>
  <v-app
    id="app"
    class="disable-dbl-tap-zoom"
    style="background-color: #f5f5f5"
  >
    <router-view></router-view>
  </v-app>
</template>

<script>
import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import globalStore from "./store.js";

export default {
  name: "App",
  mixins: [RegisterStoreModule],
  async created() {
    await this.registerStoreModule("global", globalStore);
  },
};
</script>
<style>
</style>
<style lang="scss">
@import "@/scss/variable.scss";
@import "@/scss/app.scss";
// font-family {
//   "Montserrat", "sans-serif";
// }
$primary_font_family: "Montserrat", sans-serif;
</style>
